import Dashboard from "@material-ui/icons/Dashboard";

const SideBarLinkNewLoan = [
  {
    name: "Requirement",
    icon: Dashboard,
    role: [],
    disabled: false,
    designation: [],
    children: [
      {
        name: "Income Details",
        url: "/journey/IncomeDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
    ],
  },
  {
    name: "Profile Detail",
    icon: Dashboard,
    role: [],
    disabled: false,
    designation: [],
    children: [
      {
        name: "Aadhar Details",
        url: "/journey/AadharDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      {
        name: "Income Verify",
        url: "/journey/BankAnalyser",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      // {
      //   name: "Pan Card",
      //   url: "/journey/PanPhoto",
      //   icon: Dashboard,
      //   role: [],
      //   disabled: false,
      //   designation: [],
      // },
      {
        name: "Selfie",
        url: "/journey/SelfiePhoto",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
    ],
  },
  {
    name: "General Information",
    icon: Dashboard,
    role: [],
    disabled: false,
    designation: [],
    children: [
      {
        name: "General Details",
        url: "/journey/GeneralDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      {
        name: "Reference Details",
        url: "/journey/ReferenceDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
    ],
  },
  // {
  //   name: "Decision",
  //   icon: Dashboard,
  //   role: [],
  //   disabled: false,
  //   designation: [],
  //   children: [
  //     {
  //       name: "Approval Details",
  //       url: "/journey/ApprovalDetails",
  //       icon: Dashboard,
  //       role: [],
  //       disabled: false,
  //       designation: [],
  //     },
  //     {
  //       name: "Congratulation Details",
  //       url: "/journey/CongratulationDetails",
  //       icon: Dashboard,
  //       role: [],
  //       disabled: false,
  //       designation: [],
  //     },
  //   ],
  // },
  {
    name: "Loan Details",
    icon: Dashboard,
    role: [],
    disabled: false,
    designation: [],
    children: [
      {
        name: "Loan Tenure",
        url: "/journey/LoanTenureDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      {
        name: "Repayment Schedule",
        url: "/journey/RepaymentScheduleDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
    ],
  },
  {
    name: "Bank Details",
    icon: Dashboard,
    role: [],
    disabled: false,
    designation: [],
    children: [
      {
        name: "Bank Details",
        url: "/journey/BankDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
    ],
  },
  {
    name: "Letters",
    icon: Dashboard,
    role: [],
    disabled: false,
    designation: [],
    children: [
      {
        name: "Sanction Letter",
        url: "/journey/SanctionLetter",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      {
        name: "Estamp",
        url: "/journey/EstampSanctionLetter",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      {
        name: "Esign",
        url: "/journey/EsignSanctionLetter",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
    ],
  },
  {
    name: "Disbursal",
    icon: Dashboard,
    role: [],
    disabled: false,
    designation: [],
    children: [
      {
        name: "Mandate Detail",
        url: "/journey/MandateDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      {
        name: "Disbursal Detail",
        url: "/journey/DisbursalDetails",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
      {
        name: "Disbursal Info",
        url: "/journey/DisbursalInfo",
        icon: Dashboard,
        role: [],
        disabled: false,
        designation: [],
      },
    ],
  },
];
export default SideBarLinkNewLoan;
